/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

 import React from 'react';
 import styled from 'styled-components';
 import StyledProps from '../common/theme/AppThemeInterface';
 import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';
 
 export enum ToggleTileStateEnum {
   OFF = 0,
   ON,
 }
 
 const StyledButtonBase = styled(ButtonBase)`
   border-radius: 2px;
   margin: 12px 13px 8px 0;
   display: flex;
 
   &:disabled {
     opacity: 0.25;
   }
 
   .icon {
     margin: 0 auto;
     border-radius: 2px;
     width: 24px;
     height: 24px;
     background-color: #2a3944;
     color: #ffffff;
   }
 
   .icon > .MuiSvgIcon-root {
     margin: 5px;
     width: 14px;
     height: 14px;
   }
 
   &:hover > .icon {
     opacity: 0.75;
   }
 
   .iconOn {
     background-color: #049aa3;
   }
 
   .caption {
     margin-left: 13px;
     color: white;
     font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
     font-size: 14px;
     letter-spacing: 0.58px;
   }
 `;
 
 export interface ToggleTileProps extends ButtonBaseProps {
   icon: React.ReactElement;
   caption: string;
   tileState: ToggleTileStateEnum;
   setTileState: (newTileState: ToggleTileStateEnum) => void;
 }
 const ToggleTile = (props: ToggleTileProps) => {
   const { icon, caption, tileState, setTileState, ...rest } = props;
 
   const handleTileClick = (event: any) => {
     if (tileState === ToggleTileStateEnum.ON) {
       setTileState(ToggleTileStateEnum.OFF);
     } else {
       setTileState(ToggleTileStateEnum.ON);
     }
   };
 
   return (
     <StyledButtonBase onClick={handleTileClick} {...rest}>
       <div className={`icon ${tileState === ToggleTileStateEnum.ON ? 'iconOn' : ''}`}>{icon}</div>
       <div className="caption">{caption}</div>
     </StyledButtonBase>
   );
 };
 
 export default ToggleTile;
 